import { Injectable } from "@angular/core";
import { HttpService } from "../../../core/shared/http.service";
import { Observable } from "rxjs";
import { EvaSmsCommand } from "../interfaces/eva-sms-command.interface";

@Injectable({
    providedIn: 'root'
})
export class EmnifyService {
    constructor(private readonly httpService: HttpService) { }

    public getRutOnlineStatus(guid: string): Observable<{ online: boolean }> {
        return this.httpService.get<{ online: boolean }>('Emnify/getRutOnlineStatus?guid=' + guid);
    }

    public getEvaSmsCommands(): Observable<EvaSmsCommand[]> {
        return this.httpService.get<EvaSmsCommand[]>('Emnify/sms-commands');
    }

    public EmnifySendSmsToEva(guid: string, commandId: string): Observable<void> {
        return this.httpService.post<void>(
            'Emnify/sendSms?guid=' + encodeURIComponent(guid) + '&commandId=' + encodeURIComponent(commandId),
            {}
        );
    }
}
